export const STAKING_RISK_LIST = "STAKING_RISK_LIST";
export const STAKING_RISK_ASSESSMENTS = "STAKING_RISK_ASSESSMENTS";
export const STAKING_RISK_CLASSIFICATIONS = "STAKING_RISK_CLASSIFICATIONS";
export const STAKING_RISK_CREATING = "STAKING_RISK_CREATING";
export const STAKING_RISK_CREATING_CATEGORY = "STAKING_RISK_CREATING_CATEGORY";
export const STAKING_RISK_CATEGORY_DELETE = "STAKING_RISK_CATEGORY_DELETE";
export const STAKING_RISK_BY_ID = "STAKING_RISK_BY_ID";
export const STAKING_RISK_DELETE = "STAKING_RISK_DELETE";
export const STAKING_RISK_NAME_UPDATE = "STAKING_RISK_NAME_UPDATE";
export const STAKING_RISK_ERROR = "STAKING_RISK_ERROR";
export const STAKING_RISK_ASSESSMENT_UPDATE_BY_ID =
  "STAKING_RISK_ASSESSMENT_UPDATE_BY_ID";
export const STAKING_RISK_ASSESSMENT_UPDATE_BY_ID_ERROR =
  "STAKING_RISK_ASSESSMENT_UPDATE_BY_ID_ERROR";
export const STAKING_RISK_CLASSIFICATION_UPDATE_BY_ID =
  "STAKING_RISK_CLASSIFICATION_UPDATE_BY_ID";
export const STAKING_RISK_CLASSIFICATION_UPDATE_BY_ID_ERROR =
  "STAKING_RISK_CLASSIFICATION_UPDATE_BY_ID_ERROR";
export const STAKING_RISK_DUBLICATE = "STAKING_RISK_DUBLICATE";
export const STAKING_RISK_DUBLICATE_ERROR = "STAKING_RISK_DUBLICATE_ERROR";
export const STAKING_RISK_ASSESSMENTBYID_DELETE =
  "STAKING_RISK_ASSESSMENTBYID_DELETE";
export const STAKING_RISK_CUSTOM_PARAMETER_CREATING =
  "STAKING_RISK_CUSTOM_PARAMETER_CREATING";
export const STAKING_RISK_CUSTOM_PARAMETER_ERROR =
  "STAKING_RISK_CUSTOM_PARAMETER_ERROR";
export const RESET_ASSESSMENT_UPDATE = "RESET_ASSESSMENT_UPDATE";
export const STAKING_RISK_DELETED_LIST = "STAKING_RISK_DELETED_LIST";
export const STAKING_RISK_PRODUCTS_DELETE_OR_RESTORE =
  "STAKING_RISK_PRODUCTS_DELETE_OR_RESTORE";
export const RESET_UPDATED = "RESET_UPDATED";

const stakingRiskInitialState = {
  stakingRiskList: [],
  stakingRiskByID: [],
  stakingRiskAssessment: [],
  stakingRiskClassifications: [],
  createdStakingRiskId: 0,
  dublicatedStakingRiskId: 0,
  createdStakingRiskName: "",
  singleAsset: [],
  created: false,
  categoryCreated: false,
  categoryDeleted: false,
  dublicatecreated: false,
  dublicatecreatedName: "",
  customParametercreated: false,
  updated: false,
  assessmentupdate: false,
  assessmentupdateError: "",
  classificationupdate: false,
  classificationupdateError: "",
  deleted: false,
  assessmentByIDdeleted: false,
  singleAssetErrors: "",
  deletedstakingRiskList: [],
  restoreordelete: false,
};

export function StakingRiskReducer(
  state = stakingRiskInitialState,
  { payload, type },
) {
  switch (type) {
    case STAKING_RISK_LIST:
      return {
        ...state,
        stakingRiskList: payload.result,
        assessmentByIDdeleted: false,
        customParametercreated: false,
        createdStakingRiskId: 0,
        dublicatedStakingRiskId: 0,
        created: false,
        deleted: false,
        categoryCreated: false,
        categoryDeleted: false,
      };
    case STAKING_RISK_ASSESSMENTS:
      return {
        ...state,
        stakingRiskAssessment: payload.result,
        created: false,
        deleted: false,
        assessmentByIDdeleted: false,
        customParametercreated: false,
        categoryCreated: false,
        categoryDeleted: false,
      };
    case STAKING_RISK_CLASSIFICATIONS:
      return {
        ...state,
        stakingRiskClassifications: payload.result,
        created: false,
        deleted: false,
      };
    case STAKING_RISK_BY_ID:
      return {
        ...state,
        stakingRiskByID: payload.result,
        created: false,
        updated: false,
        assessmentByIDdeleted: false,
        customParametercreated: false,
      };
    case STAKING_RISK_CREATING:
      return {
        ...state,
        createdStakingRiskId: payload?.result?.id,
        createdStakingRiskName: payload.result.name,
        created: true,
      };
    case STAKING_RISK_CREATING_CATEGORY:
      return {
        ...state,
        categoryDeleted: false,
        categoryCreated: true,
      };
    case STAKING_RISK_CATEGORY_DELETE:
      return {
        ...state,
        categoryCreated: false,
        categoryDeleted: true,
      };
    case STAKING_RISK_DUBLICATE:
      return {
        ...state,
        dublicatedStakingRiskId: payload?.result?.id,
        dublicatecreatedName: payload.result.name,
        dublicatecreated: true,
      };
    case STAKING_RISK_ASSESSMENT_UPDATE_BY_ID:
      return {
        ...state,
        created: false,
        assessmentupdate: true,
        classificationupdate: false,
      };
    case RESET_ASSESSMENT_UPDATE:
      return { ...state, assessmentupdate: false };

    case STAKING_RISK_ASSESSMENT_UPDATE_BY_ID_ERROR:
      return {
        ...state,
        assessmentupdateError: payload?.errors,
      };

    case STAKING_RISK_CLASSIFICATION_UPDATE_BY_ID:
      return {
        ...state,
        created: false,
        classificationupdate: true,
        assessmentupdate: false,
        assessmentByIDdeleted: false,
        customParametercreated: false,
      };
    case STAKING_RISK_CLASSIFICATION_UPDATE_BY_ID_ERROR:
      return {
        ...state,
        classificationupdateError: payload?.errors,
      };
    case STAKING_RISK_NAME_UPDATE:
      return {
        ...state,
        updated: true,
      };
    case STAKING_RISK_DELETE:
      return {
        ...state,
        deleted: true,
      };
    case STAKING_RISK_ERROR:
      return {
        ...state,
        singleAssetErrors: payload?.errors,
      };
    case STAKING_RISK_ASSESSMENTBYID_DELETE:
      return {
        ...state,
        assessmentByIDdeleted: true,
      };
    case STAKING_RISK_CUSTOM_PARAMETER_CREATING:
      return {
        ...state,
        customParametercreated: true,
        categoryCreated: false,
        categoryDeleted: false,
      };
    case STAKING_RISK_DELETED_LIST:
      return {
        ...state,
        deletedstakingRiskList: payload?.result,
      };
    case STAKING_RISK_PRODUCTS_DELETE_OR_RESTORE:
      return {
        ...state,
        restoreordelete: true,
      };
    case RESET_UPDATED:
      return { ...state, updated: false };
    default:
      return state;
  }
}
